import { useSiteConfig } from "@/hooks/useSiteConfig";
import smartLogo from "@/assets/smart-punta-cana-logo.png";

const LogoText = ({ className = "h-12", useFooterLogo = false }: { className?: string; useFooterLogo?: boolean }) => {
  const { getConfig } = useSiteConfig();
  
  const logoConfig = getConfig(useFooterLogo ? 'footer_logo' : 'header_logo');
  const logoUrl = logoConfig?.url || smartLogo;
  const logoAlt = logoConfig?.alt || 'Smart Punta Cana Transfer';

  return (
    <div className={`${className} flex items-center`}>
      <img 
        src={logoUrl} 
        alt={logoAlt}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};

export default LogoText;
